import React from "react";
import { Box, Typography } from "@mui/material";
import { COLORS, TYPO } from "../../styles/uiConstants";

/**
 * DrawerField — drawer formlarında kutusuz alan: üstte sade etiket, altında
 * `variant="standard"` input (alt çizgi). Çerçeve/kutu yok; alanlar boşlukla
 * ayrılır. InfoTile ile aynı yerleşim API'si (grid'de `fullWidth`), ikon yok.
 *
 * Zorunlu alanda etiketin sonuna " *" eklenir.
 *
 * @param {string} label
 * @param {React.ReactNode} children
 * @param {boolean} [fullWidth] - grid'de tüm sütunları kapla
 * @param {string} [hint] - alanın altında soluk açıklama
 * @param {object} [sx]
 */
export default function DrawerField({ label, children, fullWidth, hint, sx = {} }) {
  return (
    <Box sx={{ gridColumn: fullWidth ? "1 / -1" : "auto", minWidth: 0, ...sx }}>
      <Typography
        component="label"
        sx={{
          display: "block",
          mb: 0.25,
          fontSize: TYPO.label,
          fontWeight: 600,
          color: COLORS.slate500,
        }}
      >
        {label}
      </Typography>
      {children}
      {hint ? (
        <Typography sx={{ mt: 0.5, fontSize: TYPO.caption, color: COLORS.slate400 }}>
          {hint}
        </Typography>
      ) : null}
    </Box>
  );
}
